import { render, staticRenderFns } from "./ReferencePreview.vue?vue&type=template&id=5f1aad81&slot-scope=props&"
import script from "./ReferencePreview.vue?vue&type=script&lang=js&"
export * from "./ReferencePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports